import { deriveFieldNameFromLabel } from '@core-engine/schema/add-field/derive-field-name-from-label.js'
import { validateGeneratedFieldName } from '@core-engine/schema/add-field/validate-generated-field-name.js'

export function deriveAvailableFieldName(
  label: string,
  existingNames: Iterable<string> = []
): string {
  const usedNames = new Set(existingNames)
  const rawBase = deriveFieldNameFromLabel(label)
  let base = rawBase

  if (validateGeneratedFieldName(base).length > 0) {
    base = `${base}Field`
  }
  if (validateGeneratedFieldName(base).length > 0) {
    base = 'field'
  }

  let candidate = base
  let index = 2
  while (usedNames.has(candidate) || validateGeneratedFieldName(candidate).length > 0) {
    candidate = `${base}${index}`
    index += 1
  }

  return candidate
}
